import { useLocalStorage, UserLocale } from 'hooks/userPreferences';
import { env } from 'lib/constants/env';
import {
  DEFAULT_COUNTRY_CODE,
  DEFAULT_CURRENCY_CODE,
  DEFAULT_LOCALE_INFO,
} from 'lib/constants/siteDefaults';
import { useEffect } from 'react';

export const useResetLocale = () => {
  const {
    value: { countryCode, currencyCode },
    setStoredValue: setUserSiteLocale,
  } = useLocalStorage(UserLocale);

  useEffect(() => {
    /*
     * If the country selector flag has been turned off,
     * and the current site locale is not the default...
     * we want to reset to the default locale.
     */
    if (
      !env.NEXT_PUBLIC_COUNTRY_SELECTOR_ENABLED &&
      countryCode !== DEFAULT_COUNTRY_CODE &&
      currencyCode !== DEFAULT_CURRENCY_CODE
    ) {
      setUserSiteLocale(DEFAULT_LOCALE_INFO);
    }
  }, [setUserSiteLocale, countryCode, currencyCode]);
};
